<script>
  import { cart, deliveryMethods, paymentServices } from './storage.js';
  import Loader from '../components/Loader.svelte';
  import { getDeliveryMethods, getPaymentServices } from './requests.js';
  import { createEventDispatcher, onMount } from 'svelte';
  import { updateCart } from './requests.js';

  const dispatch = createEventDispatcher();

  let selector = false;
  let loaded = false;
  let group;

  const select = (methodId, paymentOnDelivery) => {
    $cart.delivery_method_id = methodId;
    $cart.payment_on_delivery = paymentOnDelivery;

    group = `${methodId}_${paymentOnDelivery ? 'od' : 'uf'}`;

    const payload = {
      token: $cart.token,
      delivery_method_id: $cart.delivery_method_id,
      payment_on_delivery: $cart.payment_on_delivery
    }
    updateCart($cart.id, payload).then(() => dispatch('refresh'));
    selector = false;
  }

  const fetchDeliveryMethods = async () => {
    if (!$deliveryMethods) {
      $deliveryMethods = (await getDeliveryMethods()).items;
    }

    return $deliveryMethods;
  }

  const fetchPaymentServices = async () => {
    if (!$paymentServices) {
      $paymentServices = (await getPaymentServices()).items;
    }

    return $paymentServices;
  }

  onMount(async () => {
    fetchPaymentServices();

    if ($cart && $cart.delivery_method_id) {
      await fetchDeliveryMethods();
      // TODO: fallback when delivery method will be deactivated in the meantime

      group = $cart.delivery_method_id + '_' + ($cart.payment_on_delivery ? 'od' : 'uf');
    }

    loaded = true;
  });

  const anyUpfront = (data) => {
    return data.filter(item => item['price_upfront']).length ? true : false;
  }
  const anyOnDelivery = (data) => {
    return data.filter(item => item['price_on_delivery']).length ? true : false;
  }

  $: selectedMethod = ($deliveryMethods ? $deliveryMethods : []).find(item => item['id'] === $cart.delivery_method_id);
</script>

<div class="delivery">
  {#if $cart && loaded}

    {#if selector}
      <div class="delivery__selector">
        {#await fetchDeliveryMethods()}
          <Loader />
        {:then response}
          {#if anyUpfront(response)}
            <div class="options__label">Płatność z góry:</div>
            <div class="options__list">
              {#each response.filter(item => item.price_upfront) as method}
                <label on:click={() => select(method.id, false)}>
                  <input class="option__input" type="radio" bind:group name="selectedDeliveryMethod" value={`${method.id}_uf`}>
                  <div class="option__name">{method.name}</div>
                  <div class="option__price">{ parseFloat(method.price_upfront).toFixed(2) } zł</div>
                </label>
              {/each}
            </div>
          {/if}

          {#if anyOnDelivery(response) && !$cart.any_digital}
            <div class="options__label">Płatność przy odbiorze:</div>
            <div class="options__list">
              {#each response.filter(item => item.price_on_delivery) as method}
                <label on:click={() => select(method.id, true)}>
                  <input class="option__input" type="radio" bind:group name="selectedDeliveryMethod" value={`${method.id}_od`}>
                  <div class="option__name">{method.name}</div>
                  <div class="option__price">{ parseFloat(method.price_on_delivery).toFixed(2) } zł</div>
                </label>
              {/each}
            </div>
          {/if}
        {/await}
      </div>
    {:else}

      <div class="delivery__info">
        <div class="delivery__label">
            Dostawa:
        </div>
        {#if $cart.delivery_method_id}
          <div class="delivery__value">
            {selectedMethod.name}
          </div>
        {:else}
          <a class="delivery__choice" on:click={() => selector = !selector}>wybierz</a>
        {/if}
      </div>

      {#if $cart.delivery_method_id}
        <a class="delivery__change" on:click={() => selector = !selector}>zmień</a>
      {/if}
    {/if}
  {:else if $cart}
    <Loader />
  {/if}
</div>


<style>
  .delivery {
    border: 1px solid #e0e0e0;
    margin-bottom: 15px;
    padding: 20px 25px;
  }

  .delivery__info {
    display: flex;
    justify-content: space-between;
  }

  .delivery__value {
    font-weight: bold;
  }

  .delivery__change {
    font-size: 0.8em;
    text-align: right;
    display: inherit;
    margin-bottom: -3px;
  }

  .options__label {
    font-weight: bold;
  }

  .options__list label {
    cursor: pointer;
    display: flex;
    justify-content: space-between;
    margin-left: -5px;
    margin-right: -5px;
    padding-left: 5px;
    padding-right: 5px;
  }

  .option__input {
    margin: auto;
    margin-right: 7px;
    flex-grow: 0;
  }

  .option__name {
    flex-grow: 1;
  }

  .option__price {
    text-align: right;
    flex-grow: 0;
  }

  .options__list label:hover {
    background-color: #ececec;
    color: #323d8a;
  }

  .options__list + .options__label {
    margin-top: 15px;
  }

  @media (max-width: 767px) {
    .delivery {
      margin-bottom: 10px;
      padding: 10px;
    }
  }
</style>
